<template>
  <el-dialog title="编辑角色" :visible="visible" width="400px" :close-on-click-modal="false" @close="handleClose">
    <el-form :model="form" :rules="rules" ref="formRef" label-width="100px" label-position="left">
      <el-form-item label="角色名称" prop="roleName">
        <el-input v-model="form.roleName" placeholder="请输入角色名称" />
      </el-form-item>
      <el-form-item label="角色标识" prop="roleKey">
        <el-input v-model="form.roleKey" placeholder="请输入角色标识" />
      </el-form-item>
      <el-form-item label="角色顺序" prop="sort">
        <el-input-number v-model="form.sort" :min="0" />
      </el-form-item>
      <el-form-item label="状态">
        <el-radio-group v-model="form.status">
          <el-radio label="1">启用</el-radio>
          <el-radio label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { roleDetail, roleUpdate } from '@/api/api'

export default {
  name: 'EditRoleDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    roleId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      form: {
        roleName: '',
        roleKey: '',
        sort: 0,
        status: '1'
      },
      rules: {
        roleName: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        roleKey: [{ required: true, message: '请输入角色标识', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入角色顺序', trigger: 'blur' }]
      },
      loading: false,
      detailLoading: false
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal && this.roleId && this.roleId !== '') {
          this.fetchRoleDetail()
        }
      },
      immediate: false
    }
    // 移除 roleId 的 watcher，避免重复调用接口
    // 当 visible 变为 true 时，会通过上面的 watcher 调用 fetchRoleDetail
  },
  methods: {
    // 获取角色详情
    fetchRoleDetail() {
      if (!this.roleId) return

      this.detailLoading = true
      console.log('调用roleDetail接口，参数:', { id: this.roleId });
      // 确保传递给roleDetail接口的参数是一个对象
      roleDetail({ id: this.roleId })
        .then(response => {
          console.log('roleDetail接口响应:', response);
          if (response && response.code === 200 && response.data && response.data.id) {
            const roleData = response.data.id
            this.form = {
              roleName: roleData.title || '',
              roleKey: roleData.slug || '',
              sort: roleData.sort || 0,
              status: roleData.status !== null && roleData.status !== undefined ? roleData.status.toString() : '1'
            }
          } else {
            this.$message.error('获取角色详情失败')
          }
        })
        .catch(error => {
          console.error('获取角色详情失败:', error)
          this.$message.error('获取角色详情异常，请重试')
        })
        .finally(() => {
          this.detailLoading = false
        })
    },
    // 处理提交
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.loading = true
          // 准备调用接口的参数，映射字段
          const params = {
            id: this.roleId,
            title: this.form.roleName,
            slug: this.form.roleKey,
            sort: this.form.sort !== null && this.form.sort !== undefined ? this.form.sort.toString() : '0',
            status: this.form.status
          }
          // 调用roleUpdate接口
          roleUpdate(params)
            .then(response => {
              if (response && response.code === 200) {
                this.$message.success('角色编辑成功')
                this.$emit('submit', this.form)
                this.handleClose()
              } else {
                this.$message.error('角色编辑失败：' + (response.message || '未知错误'))
              }
            })
            .catch(error => {
              console.error('角色编辑失败:', error)
              this.$message.error('角色编辑异常，请重试')
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    // 处理关闭
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped></style>